import React from "react";

const BirthCertHeadContent = () => {
  return (
    <div className="birthCertHeadContentContainer">
      <h2>
        Birth <span>Apostille</span> Certificate in Bangalore
      </h2>
      <p>
        The birth certificate apostille is a critical process for individuals
        planning to move, work, study, or reside abroad. This process involves
        the authentication of a birth certificate, ensuring its acceptance in
        foreign countries that are members of the Hague Apostille Convention.
        Goodway Attestation Services in Bangalore provides specialized
        assistance for obtaining birth certificate apostille, making the process
        seamless and efficient.
      </p>
    </div>
  );
};

export default BirthCertHeadContent;
